import { useState } from "react";
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { truncateText } from "../../../utils";
import FtmRequests from "../../ftmRequests/FtmRequests";

const Table = ({ jobs }) => {
    const [selectJob, setSelectJob] = useState(null);
    const [showRequests, setShowRequests] = useState(false);

    const openRequests = () => setShowRequests(true);
    const closeRequests = () => setShowRequests(false);

    const handleSelectRequest = (request) => {
        setSelectJob(request);
        openRequests();
    };

    return (
        <div className="table-responsive p-0">
            <table className="table align-items-center mb-0">
                <thead>
                    <tr>
                        {[
                            '#',
                            'Job address',
                            'Description',
                            'Tradesperson',
                            'Service category',
                            'Requests count'
                        ].map((text, index) => (
                            <th
                                key={index}
                                className={`text-uppercase text-secondary text-sm font-weight-bolder opacity-7 ${text === 'Requests count' ? 'text-center' : ''}`}
                            >
                                {text}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {jobs.map((job, index) => (
                        <tr key={index}>
                            <td className="align-middle">
                                <span className="text-secondary text-sm font-weight-bold">{job.job_id}</span>
                            </td>
                            <td className="align-middle">
                                <span className="text-secondary text-sm font-weight-bold">{job.job_address}</span>
                            </td>
                            <td className="align-middle">
                                <span className="text-secondary text-sm font-weight-bold">{truncateText(job.job_description, 30)}</span>
                            </td>
                            <td>
                                <div className="d-flex px-2 py-1">
                                    <div>
                                        <img src={job.ftm.ftm_profile_image_path || "/assets/img/lock_user.png"} className="avatar avatar-sm me-3 border-radius-lg" alt="user1" />
                                    </div>
                                    <div className="d-flex flex-column justify-content-center">
                                        <h6 className="mb-0 text-sm">{job.ftm.ftm_forename} {job.ftm.ftm_surname}</h6>
                                        <p className="text-sm text-secondary mb-0">{job.ftm.ftm_vehicle_number}</p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div className="d-flex px-2 py-1">
                                    <div>
                                        <i className="material-icons me-2" style={{ fontSize: '35px' }}>{job.sub_skill.skill.skill_web_app_icon}</i>
                                    </div>
                                    <div className="d-flex flex-column justify-content-center">
                                        <h6 className="mb-0 text-sm">{job.sub_skill.sub_skill_name}</h6>
                                        <p className="text-sm text-secondary mb-0">{job.sub_skill.skill.skill_name}</p>
                                    </div>
                                </div>
                            </td>
                            <td className="text-center">
                                <IconButton size="large" onClick={() => handleSelectRequest(job)}>
                                    <VisibilityIcon fontSize="inherit" />
                                </IconButton>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {selectJob && (
                <FtmRequests
                    show={showRequests}
                    handleClose={closeRequests}
                    job_id={selectJob?.job_id}
                    undecided={true}
                />
            )}
        </div>
    );
}

export default Table;